const initIubendaProof = () => {
    document.querySelectorAll('form[method=POST]').forEach(function (form) {
        if (form.querySelector("#iubenda_proof")) {
            const innerHTML = btoa(encodeURI(form.innerHTML));
            form.querySelector("#iubenda_proof").innerHTML = innerHTML;
        }
    });
};
